// Async precheckout questions polling

export function initPrecheckoutPolling() {
  const container = document.getElementById('precheckout-async-loader');
  if (!container) return;

  const jobId = container.dataset.jobId;
  const pollPath = container.dataset.pollPath;

  if (!jobId || !pollPath) {
    console.error('Missing job ID or poll path for precheckout polling');
    return;
  }

  startPolling(jobId, pollPath);
}

function startPolling(jobId, pollPath) {
  const maxAttempts = 45; // 90 seconds max (2000ms * 45)
  let attempts = 0;

  const poll = () => {
    attempts++;

    fetch(`${pollPath}?job_id=${jobId}`)
      .then(response => response.json())
      .then(data => {
        if (data.status === 'completed') {
          window.location.href = data.redirect_url;
        } else if (data.status === 'error') {
          handleError(data.error || 'An error occurred loading the form');
        } else if (data.status === 'pending' && attempts < maxAttempts) {
          setTimeout(poll, 2000);
        } else if (attempts >= maxAttempts) {
          handleTimeout();
        }
      })
      .catch(error => {
        console.error('Polling error:', error);
        if (attempts < maxAttempts) {
          setTimeout(poll, 2000);
        } else {
          handleTimeout();
        }
      });
  };

  poll();
}

function handleError(message) {
  const container = document.getElementById('precheckout-async-loader');
  if (!container) return;

  container.innerHTML = `
    <div class="cart-empty-state padding-40">
      <p class="regular-17 gray-65 text-center">${message}</p>
      <p class="regular-17 gray-65 text-center">
        <a href="${window.location.href}" class="underline">Please refresh the page</a>
      </p>
    </div>
  `;
}

function handleTimeout() {
  handleError('Loading is taking longer than expected. Please refresh the page.');
}

document.addEventListener('DOMContentLoaded', initPrecheckoutPolling);

window.initPrecheckoutPolling = initPrecheckoutPolling;
